import { appSyncApiKey } from "@web/config/next"
import { useCallback } from "react"

export const getInitials = (name: string) => {
  const emoji =
    /([#0-9]\u20E3)|[\xA9\xAE\u203C\u2047-\u2049\u2122\u2139\u3030\u303D\u3297\u3299][\uFE00-\uFEFF]?|[\u2190-\u21FF][\uFE00-\uFEFF]?|[\u2300-\u23FF][\uFE00-\uFEFF]?|[\u2460-\u24FF][\uFE00-\uFEFF]?|[\u25A0-\u25FF][\uFE00-\uFEFF]?|[\u2600-\u27BF][\uFE00-\uFEFF]?|[\u2900-\u297F][\uFE00-\uFEFF]?|[\u2B00-\u2BF0][\uFE00-\uFEFF]?|(?:\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDEFF])[\uFE00-\uFEFF]?|[\u20E3]|[\u26A0-\u3000]|\uD83E[\udd00-\uddff]|[\u00A0-\u269F]/g

  const tmp = name
    .replace(emoji, "")
    .trim()
    .split(" ")
    .map(function (item) {
      return item[0]
    })
    .join("")

  const { 0: first, [tmp.length - 1]: last } = tmp

  return `${first}${last}`.toUpperCase()
}

export const getCurrentDate = () => {
  return new Date()
}

const CDN_URL = process.env.NEXT_PUBLIC_CDN_URL || "https://media-exp1.licdn.com"

export const getAvatarUrl = (avatarThumbS3Key?: string | null) => {
  if (!avatarThumbS3Key) return ""

  return CDN_URL + "/" + avatarThumbS3Key
}
export const getLogoUrl = (logoKey: string) => {
  return CDN_URL + "/" + logoKey
}
type CopyFn = (text: string) => Promise<boolean> // Return success

type Result = {
  copy: CopyFn
}

export function useCopyToClipboard(): Result {
  const copy: CopyFn = useCallback(async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn("Clipboard not supported")
      return false
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (error) {
      console.warn("Copy failed", error)
      return false
    }
  }, [])

  return { copy }
}

/**
 * If the API key is present in headers and metches value in env, return this key. Otherwise, return null.
 */
export const getE2eTestingApiKey = (headers: Headers) => {
  const e2eTestingApiKey = headers.get("x-e2e-testing-api-key")
  const isValidTestingKey = typeof e2eTestingApiKey == "string" && e2eTestingApiKey === appSyncApiKey

  return isValidTestingKey ? e2eTestingApiKey : null
}

export const getWindow = () => {
  if (typeof window === "undefined") {
    return undefined
  }

  return window
}
